module.exports = __webpack_public_path__ + "media/images/past_order_history/ic_Calendar-b91e9371888610e251eabcb51f2ef635.png";